
















































































































































import {Vue, Component, Watch} from 'vue-property-decorator'
import {Osoba} from '../../../services/BackendProxies';
import dataProxyService from '../../../services/data-proxy.service';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PregledZaposlenog extends mixins(ComponentBaseMixin) {
    osoba = new Osoba();

    async created() {
        this.load();
    }

    async load() {
        const idZaposlenog = +this.$route.params['id'];
        this.osoba = await this.loadData(() => dataProxyService.vratiOsobu(idZaposlenog))();
    }

    @Watch('$route') onRouteChange() {
        this.load();
    }

    otvoriDetalje(id) {
        this.$router.replace(`/podaci-zaposlenog/${id}`);
    }
}
